



import Vue from 'vue';
export default Vue.extend({
    name: 'Home',
    beforeMount() {
        if (this.$route.query.p) {
            console.log('set referer = ', this.$route.query.p);
            window.localStorage.setItem('referer', String(this.$route.query.p));
            let query = Object.assign({}, this.$route.query);
            if (Object.keys(query).length !== 0) {
                delete query.p;
                this.$router.replace({ query });
            }
        }
        const token = window.localStorage.getItem('token');
        const id = window.localStorage.getItem('id');
        if (token && id) {
            window.location.href = '/#/webtrading';
        } else {
            window.location.href = '/#/login';
        }
    },

    data: () => ({}),
});
